import * as requestFromServer from "./StudentBookReportCrud";
import { callTypes, studentBookReportSlice } from "./StudentBookReportSlice";

const {actions} = studentBookReportSlice;

export const getStandardReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStandardReport(queryParams)
    .then(response => {
      dispatch(actions.reportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllStandardReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllStandardReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getBookAndPageNumberReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getBookAndPageNumberReport(queryParams)
    .then(response => {
      dispatch(actions.reportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllBookAndPageNumberReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllBookAndPageNumberReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getMonthlyReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getMonthlyReport(queryParams)
    .then(response => {
      dispatch(actions.reportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllMonthlyReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllMonthlyReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getSections = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getSections()
    .then(response => {
      dispatch(actions.sectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudents = (term, sectionId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getStudents(term, sectionId)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTeachers = term => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTeachers(term)
    .then(response => {
      dispatch(actions.teachersFetched(response.data));
    })
    .catch(error => {
      
    });
};


export const cleanStudentsState = () => dispatch => {
  dispatch(actions.studentsStateCleaned());
}

export const cleanStudentBookReportState = () => dispatch => {
  dispatch(actions.studentBookReportStateCleaned());
}